import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import AddUsIndiaEnergyStorage from "./AddUsIndiaEnergyStorage";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";

const UsIndiaEnergyStorage = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [data, setData] = useState<any>(null);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        getData();
    }, [])

    const getData = () => {
        setLoading(true);
        WebService.getAPI({
            action: `us-india-energy-storage/getContent`
        })
            .then((res: any) => {
                setData(res.data);
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
            });
    }

    return (
        <>
            <AddUsIndiaEnergyStorage
                show={showAddModal}
                handleClose={() => {
                    setShowAddModal(false);
                    getData();
                }}
                data={data}
            />
            <div className="events-main">
                <Card className='event-card'>
                    {
                        isLoading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 100 }}>
                                <span className="spinner-border" role="status" aria-hidden="true"></span>
                            </div>
                        ) :
                            <>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div className='page-title'>US India Energy Storage Task Force (ESTF)</div>
                                    <CustomButton
                                        isLoading={false}
                                        label={data ? 'Edit' : 'Add'}
                                        onClick={() => {
                                            setShowAddModal(true);
                                        }}
                                        style={{ width: 100 }}
                                    />
                                </div>
                                <div>
                                    {
                                        data == null ?
                                            <div className="text-center my-5">No data found</div>
                                            :
                                            <>
                                                {data.logo && <img src={data.logo} alt="Logo" className="img-fluid" />}
                                                {data.title && <h3 className="mt-3">{data.title}</h3>}
                                                {data.images && data.images.length > 0 && data.images.map((img: string, index: number) => (
                                                    <img key={index} src={img} alt={`Image ${index + 1}`} className="my-2 rounded" height={300} />
                                                ))}
                                                {data.missionContent && data.missionContent.length > 0 && <div><strong>Mission Content</strong></div>}
                                                {data.missionContent && data.missionContent.length > 0 && data.missionContent.map((content: any, index: number) => (
                                                    <div>
                                                        <img src={content.image} alt={`Mission Content ${index + 1}`} className="my-2 rounded" height={100} />
                                                        <div className="font-13">{content.title}</div>
                                                        <div className="font-13">{content.description}</div>
                                                    </div>
                                                ))}
                                                {data.workingGroup && data.workingGroup.length > 0 && <div><strong>Working Group</strong></div>}
                                                {data.workingGroup && data.workingGroup.length > 0 && data.workingGroup.map((content: any, index: number) => (
                                                    <div>
                                                        <img src={content.image} alt={`Working Group ${index + 1}`} className="my-2 rounded" height={100} />
                                                        <div className="font-13">{content.title}</div>
                                                        <div className="font-13">{content.description}</div>
                                                    </div>
                                                ))}
                                                {data.coChair && data.coChair.length > 0 && <div><strong>Co-Chairs</strong></div>}
                                                {data.coChair && data.coChair.length > 0 && data.coChair.map((content: any, index: number) => (
                                                    <div>
                                                        <img src={content.image} alt={`Co-Chair ${index + 1}`} className="my-2 rounded" height={100} />
                                                        <div className="font-13">{content.title}</div>
                                                        <div className="font-13">{content.designation}</div>
                                                    </div>
                                                ))}
                                                {data.steeringCommittee && data.steeringCommittee.length > 0 && <div><strong>Steering Committee</strong></div>}
                                                {data.steeringCommittee && data.steeringCommittee.length > 0 && data.steeringCommittee.map((content: any, index: number) => (
                                                    <div>
                                                        <img src={content.image} alt={`Steering Committee ${index + 1}`} className="my-2 rounded" height={100} />
                                                        <div className="font-13">{content.title}</div>
                                                        <div className="font-13">{content.designation}</div>
                                                    </div>
                                                ))}
                                                {data.coordinationTeam && data.coordinationTeam.length > 0 && <div><strong>Coordination Team</strong></div>}
                                                {data.coordinationTeam && data.coordinationTeam.length > 0 && data.coordinationTeam.map((content: any, index: number) => (
                                                    <div>
                                                        <img src={content.image} alt={`Coordination Team ${index + 1}`} className="my-2 rounded" height={100} />
                                                        <div className="font-13">{content.title}</div>
                                                        <div className="font-13">{content.designation}</div>
                                                    </div>
                                                ))}
                                                {data.secretariat && data.secretariat.length > 0 && <div><strong>Secretariat</strong></div>}
                                                {data.secretariat && data.secretariat.length > 0 && data.secretariat.map((content: any, index: number) => (
                                                    <div>
                                                        <img src={content.image} alt={`Secretariat ${index + 1}`} className="my-2 rounded" height={100} />
                                                        <div className="font-13">{content.title}</div>
                                                        <div className="font-13">{content.designation}</div>
                                                    </div>
                                                ))}
                                                {data.documents && data.documents.length > 0 && <div><strong>Documents</strong></div>}
                                                {data.documents && data.documents.length > 0 && data.documents.map((content: any, index: number) => (
                                                    <div onClick={() => {
                                                        if (content.file) {
                                                            window.open(content.file, '_blank');
                                                        } else {
                                                            toast.error("No document found");
                                                        }
                                                    }}>
                                                        <img src={content.image} alt={`Document ${index + 1}`} className="my-2 rounded" height={100} />
                                                    </div>
                                                ))}
                                                {data.members && data.members.length > 0 && <div><strong>ESTF Members</strong></div>}
                                                {data.members && data.members.length > 0 && data.members.map((content: any, index: number) => (
                                                    <div>
                                                        <div className="font-13">{content}</div>
                                                    </div>
                                                ))}
                                            </>
                                    }
                                </div>
                            </>
                    }
                </Card>
            </div>
        </>
    )
}

export default UsIndiaEnergyStorage;